<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container *ngIf="!!roleAndPermissionsViewModel.role.id">
        Edit Role
      </ng-container>
      <ng-container *ngIf="!roleAndPermissionsViewModel.role.id">
        Add Role
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">

    <div class="card-box">
      <ul ngbNav #nav="ngbNav" class="nav nav-tabs" (activeIdChange)="initTable($event)">
        <li [ngbNavItem]="1">
          <a ngbNavLink>Role Details</a>
          <ng-template ngbNavContent>
            <form class="form-horizontal" role="form" autocomplete="off">

              <div class="form-group row">
                <label for="name" class="col-3 col-form-label">Name</label>
                <div class="col-9">
                  <input [(ngModel)]="roleAndPermissionsViewModel.role.name" [ngModelOptions]="{standalone: true}" class="form-control" id="name" placeholder="Enter Role Name">
                </div>
              </div>

              <div class="form-group row">
                <label for="Description" class="col-3 col-form-label">Description</label>
                <div class="col-9">
                  <input [(ngModel)]="roleAndPermissionsViewModel.role.description" [ngModelOptions]="{standalone: true}" class="form-control" id="Description" placeholder="Enter Role Description">
                </div>
              </div>

              <div class="form-group row">
                <label for="Description" class="col-3 col-form-label">Permissions</label>
                <div class="col-9">
                  <ng-select2 [(ngModel)]="selectedClaims" [ngModelOptions]="{standalone: true}" [data]="allClaims" [options]="select2options"></ng-select2>
                </div>
              </div>

              <div class="form-group row offset-3 col-9" *ngIf="!!identityResult && !identityResult.succeeded">
                <ng-container *ngFor="let error of identityResult.errors">
                  <p class="col-12 text-danger">{{error.description}}</p>
                </ng-container>
              </div>

            </form>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>Users</a>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-12 mb-2">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let userByRole of usersByRole">
                    <td>{{ userByRole.name }}</td>
                    <td>{{ userByRole.email }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="tab-pane">
      </div>

      <div class="form-group mb-0 justify-content-end row">
        <div class="col-9">
          <button type="submit" *ngIf="canAdd" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
            Save
          </button>
          <button type="submit" *ngIf="canEdit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
            Update
          </button>
          <button [disabled]="!canDelete" *ngIf="canDelete" type="submit" class="btn btn-danger waves-effect waves-light float-right mr-1" (click)="delete()">
            Delete
          </button>
        </div>
      </div>
    </div>


  </div>
</div>
